import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import VideoModal from '../../HomePages/home-one/section/videoModal';
import ImageWithBasePath from '../../../core/common/imageWithBasePath';
import { all_routes } from '../../router/all_routes';
// import TailwindAccordion from './Accordin'; // Uncomment when ready

interface BannerProps {
    apiValues: any;
}



const WhyStudyAbroad: React.FC<BannerProps> = ({ apiValues }) => {

    const [showModal, setShowModal] = useState(false);
    const videoUrl = 'https://www.youtube.com/embed/1trvO6dqQUI';

    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    const route = all_routes;

    return (
        <>

            {/* Course Detail Section */}
            <section className="course-details">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="course-page-content">
                                {/* Overview Card */}
                                <div className="card mb-4">
                                    <div className="card-body">
                                        <h5 className="subs-title mb-3">
                                            {apiValues?.title || "Overview"}

                                        </h5>
                                        {/* <h6 className="mb-3">Course Description</h6> */}
                                        <p>
                                            {apiValues?.description || "est and Weed Control is the science of utilising tools and tactics to assess"}
                                        </p>
                                        {/* <p>
                                            This course will get you familiar with Generative AI and the effective use of ChatGPT—
                                            perfect for beginners. You will also learn advanced prompting techniques
                                            to take your Prompt Engineering skills to the next level!
                                        </p> */}




                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default WhyStudyAbroad;
